export default __webpack_public_path__ + "static/media/plin.c74da852.png";